<template>
<div class="dizhi">
<el-dialog  title="修改地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="xiugaiDizhiFlag" width="1200px" center>
  <el-form :inline="true" ref="dataFrom" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline jiaoyan" label-width="80px" size="mini">
    <div v-if="zidanList[0].orderState===0">
      <el-form-item label=" " label-width="10px">
          <el-button type="text"  @click="addxzdzFn(2)"><i class="el-icon-location-outline  dizhiIcon" style="color:#67C23A"></i><span class="red">*</span>发货地址薄</el-button>
      </el-form-item>
      <div>
         <el-form-item    label="发货人:"  v-if="goodform.deliverAddressId">
            <div style="width:70px">{{goodform.deliverPerson}}</div>
          </el-form-item>
          <el-form-item label="电话:" prop="deliverPhone" v-if="goodform.deliverAddressId">
            <div style="width:100px">{{goodform.deliverPhone}}</div>
          </el-form-item>
          <el-form-item   label="流向:" v-if="goodform.deliverAddressId">
            <div style="width:230px">{{goodform.startDirection}}</div>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" v-if="goodform.deliverAddressId">
            <div style="min-width:150px">{{goodform.deliverAddress}}</div>
          </el-form-item>
      </div>
    </div>
    <div v-if="zidanList[1].orderState===0">
      <el-form-item label=" " label-width="10px">
        <el-button type="text"  @click="addxzdzFn(1)"><i class="el-icon-location-outline dizhiIcon" style="color:#F56C6C"></i><span class="red">*</span>收货地址薄</el-button>
      </el-form-item>
      <div>
        <el-form-item label="收货人:" v-if="goodform.receivingAddressId">
          <div style="width:70px">{{goodform.receivingPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="receivingPhone" v-if="goodform.receivingAddressId">
          <div style="width:100px">{{goodform.receivingPhone}}</div>
        </el-form-item>
        <el-form-item label="流向:" prop="receivingCompany" v-if="goodform.receivingAddressId">
          <div style="width:230px">{{goodform.endDirection}}</div>
        </el-form-item>
        <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" v-if="goodform.receivingAddressId">
          <div style="min-width:150px">{{goodform.receivingAddress}}</div>
        </el-form-item>
      </div>
    </div>
  </el-form>
  <span slot="footer" class="dialog-footer">
      <el-button  @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="saveFn">提交</el-button>
    </span>
</el-dialog>
<el-dialog  title="选择地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="dialogVisible = false"
  :visible.sync="dialogVisible" width="1300px" center append-to-body>
  <div>
    <publicAddress v-if="dialogVisible" :iszujian="1" @handleCurrentChange="handleCurrentChange"></publicAddress>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
  </span>
</el-dialog>

</div>
</template>

<script>
import publicAddress from '@/views/newTMS/publicFiles/publicAddress.vue'
import { updateSgStowageReceiveDeliver } from '@/api/newTMS'
export default {
  name: 'addDizhi',
  components: {
    publicAddress
  },
  props: {
    xiugaiDizhiFlag: {
      type: Boolean,
      default: false
    },
    zidanList: {
      type: Array,
      default: function () {
        return []
      }
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      addressType: 1,
      goodform: {}
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.goodform.mainOrderId = this.rowData.orderId
    let row = this.rowData
    if (this.zidanList[0].orderState === 0) {
      this.goodform.startOrderId = this.zidanList[0].orderId
      this.$set(this.goodform, 'deliverCompany', row.deliverCompany)
      this.$set(this.goodform, 'deliverPerson', row.deliverPerson)
      this.$set(this.goodform, 'deliverPhone', row.deliverPhone)
      this.$set(this.goodform, 'deliverAddress', row.deliverAddress)
      this.$set(this.goodform, 'deliverTaxpayerNumber', row.deliverTaxpayerNumber)
      this.$set(this.goodform, 'startDirection', row.startDirection)
      this.goodform.deliverProvinceCode = row.deliverProvinceCode
      this.goodform.deliverCityCode = row.deliverCityCode
      this.goodform.deliverAreaCode = row.deliverAreaCode
      this.goodform.deliverProvinceName = row.deliverProvinceName
      this.goodform.deliverCityName = row.deliverCityName
      this.goodform.deliverAreaName = row.deliverAreaName
      this.goodform.deliverAddressId = row.deliverAddressId
      this.goodform.deliverLongitude = row.deliverLongitude
      this.goodform.deliverLatitude = row.deliverLatitude
    }
    if (this.zidanList[1].orderState === 0) {
      this.goodform.endOrderId = this.zidanList[1].orderId
      this.$set(this.goodform, 'receivingCompany', row.receivingCompany)
      this.$set(this.goodform, 'receivingPerson', row.receivingPerson)
      this.$set(this.goodform, 'receivingPhone', row.receivingPhone)
      this.$set(this.goodform, 'receivingAddress', row.receivingAddress)
      this.$set(this.goodform, 'receivingTaxpayerNumber', row.receivingTaxpayerNumber)
      this.$set(this.goodform, 'endDirection', row.endDirection)
      this.goodform.receivingProvinceCode = row.receivingProvinceCode
      this.goodform.receivingCityCode = row.receivingCityCode
      this.goodform.receivingAreaCode = row.receivingAreaCode
      this.goodform.receivingProvinceName = row.receivingProvinceName
      this.goodform.receivingCityName = row.receivingCityName
      this.goodform.receivingAreaName = row.receivingAreaName
      this.goodform.receivingAddressId = row.receivingAddressId
      this.goodform.receivingLongitude = row.receivingLongitude
      this.goodform.receivingLatitude = row.receivingLatitude
    }
    console.log(this.goodform)
  },
  methods: {
    saveFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      updateSgStowageReceiveDeliver(this.goodform).then(res => {
        loading.close()
        this.$emit('update:xiugaiDizhiFlag', false)
        this.$parent.searchFn()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 选择地址
    addxzdzFn (flag) {
      this.addressType = flag
      this.dialogVisible = true
    },
    handleCurrentChange (row) {
      this.dialogVisible = false
      if (this.addressType == 1) {
        // 收货
        this.$set(this.goodform, 'receivingCompany', row.company)
        this.$set(this.goodform, 'receivingPerson', row.person)
        this.$set(this.goodform, 'receivingPhone', row.phone)
        this.$set(this.goodform, 'receivingAddress', row.address)
        this.$set(this.goodform, 'receivingTaxpayerNumber', row.taxpayerNumber)
        this.$set(this.goodform, 'endDirection', row.name)
        this.goodform.receivingProvinceCode = row.provinceCode
        this.goodform.receivingCityCode = row.cityCode
        this.goodform.receivingAreaCode = row.areaCode
        this.goodform.receivingProvinceName = row.provinceName
        this.goodform.receivingCityName = row.cityName
        this.goodform.receivingAreaName = row.areaName
        this.goodform.receivingAddressId = row.id
        this.goodform.receivingLongitude = row.longitude
        this.goodform.receivingLatitude = row.latitude
      } else {
        // 发货
        this.$set(this.goodform, 'deliverCompany', row.company)
        this.$set(this.goodform, 'deliverPerson', row.person)
        this.$set(this.goodform, 'deliverPhone', row.phone)
        this.$set(this.goodform, 'deliverAddress', row.address)
        this.$set(this.goodform, 'deliverTaxpayerNumber', row.taxpayerNumber)
        this.$set(this.goodform, 'startDirection', row.name)
        this.goodform.deliverProvinceCode = row.provinceCode
        this.goodform.deliverCityCode = row.cityCode
        this.goodform.deliverAreaCode = row.areaCode
        this.goodform.deliverProvinceName = row.provinceName
        this.goodform.deliverCityName = row.cityName
        this.goodform.deliverAreaName = row.areaName
        this.goodform.deliverAddressId = row.id
        this.goodform.deliverLongitude = row.longitude
        this.goodform.deliverLatitude = row.latitude
      }
    },
    closeDialog () {
      this.$emit('update:xiugaiDizhiFlag', false)
    }

  }

}
</script>

<style scoped lang='less'>
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.dizhiIcon{
  font-size: 18px;
  margin-right: 4px;
}
.dizhi{
  /deep/.el-form-item--mini.el-form-item{
    margin-bottom:0!important;
  }
}
</style>
